export const generateSortList = (sortField: SortFields[]): SortFieldsConvert[] =>
    sortField
        ?.filter((i: any) => i.value !== 'position')
        ?.map((item) => {
            switch (item.value) {
                case 'price':
                    return [
                        {
                            title: `Lowest Price`,
                            key: item.value,
                            value: 'ASC',
                            combineValue: `${item.value}-ASC`
                        },
                        {
                            title: `Highest Price`,
                            key: item.value,
                            value: 'DESC',
                            combineValue: `${item.value}-DESC`
                        }
                    ];

                case 'product_id':
                    return [
                        // {
                        //   title: `Top Reivews`,
                        //   key: item.value,
                        //   value: "ASC",
                        //   combineValue: `${item.value}-ASC`,
                        // },
                        {
                            title: `Most Recent`,
                            key: item.value,
                            value: 'DESC',
                            combineValue: `${item.value}-DESC`
                        }
                    ];
                case 'best_sales':
                    return [
                        {
                            title: `Best Selling`,
                            key: item.value,
                            value: 'DESC',
                            combineValue: `${item.value}-DESC`
                        }
                    ];
                default:
                    return [
                        {
                            title: `${item.label} Ascending`,
                            key: item.value,
                            value: 'ASC',
                            combineValue: `${item.value}-ASC`
                        },
                        {
                            title: `${item.label} Descending`,
                            key: item.value,
                            value: 'DESC',
                            combineValue: `${item.value}-DESC`
                        }
                    ];
            }
        })
        ?.flat() || [];

export const createSortObject = (querySort: string, specifyKey: string = '-') => {
    if (typeof querySort !== 'string') return null;
    const splitter = querySort.split(specifyKey);
    if (!splitter || (splitter && splitter.length < 2)) return {};
    if (splitter[1] !== 'ASC' && splitter[1] !== 'DESC') {
        return {};
    }

    return {
        [splitter[0]]: splitter[1]
    };
};

export const validSortValue = (sort: any) => {
    const splitter = sort.split('-');
    if (!splitter || splitter.length !== 2) return false;

    return splitter[1] === 'ASC' || splitter[1] === 'DESC';
};
